import React from 'react';
import PropTypes from 'prop-types';
import ModalContainer from '../../modal-container/ModalContainer';

const PageManageModal = function PageManageModal(props) {
    const {
        button, content, title, confirmButtonText, show, setShow, modalcardstyle,
    } = props;

    // We need to tell the parent page to set up the modal background
    // because the contents of an iframe cannot extend or access the parent page.
    window.parent.postMessage(['modalContainer', show], '*');

    return (
        <>
            {button}
            <ModalContainer
                modaltitle={title}
                modalclosebuttontext=""
                confirmbuttontext={confirmButtonText}
                showheader
                showmodal={show}
                toggleshow={setShow}
                modalcardstyle={modalcardstyle}
            >
                <div className="columns">
                    <div className="column" style={{ flexGrow: 6, flexShrink: 7 }}>
                        {content}
                    </div>
                </div>
            </ModalContainer>
        </>
    );
};

PageManageModal.propTypes = {
    button: PropTypes.node.isRequired,
    content: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    confirmButtonText: PropTypes.string,
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    modalcardstyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

PageManageModal.defaultProps = {
    confirmButtonText: 'Confirm',
    modalcardstyle: {},
};

export default PageManageModal;
